import React from "react"

import RightChevron from "../images/chevron-right.svg"
import { CommunityWrapper } from "../Community/styled"
import { SubDivider } from "../Menu/styled"
import { SubItemList, SubMenuItem } from "../SubMenu/styled"
import { SubNavOptions } from "../types"

const mentalHealthTestItems: SubNavOptions[] = [
  {
    subMenuTitle: "Online anxiety test",
    link: "/online/free-online-anxiety-test",
  },
  {
    subMenuTitle: "Online ADHD test",
    link: "/online/online-adhd-self-test",
  },
  {
    subMenuTitle: "Online depression test",
    link: "/online/free-online-depression-test",
  },
  {
    subMenuTitle: "Online bipolar test",
    link: "/online/online-bipolar-disorder-screener",
  },
]

const MentalHealthTest = () => {
  return (
    <CommunityWrapper>
      <h6>Free mental health tests</h6>
      <SubDivider $showOnDesktop />
      <SubItemList>
        {mentalHealthTestItems.map(item => (
          <a href={item.link || "/"} key={item.subMenuTitle}>
            <SubMenuItem key={item.subMenuTitle}>
              <button>{item.subMenuTitle}</button>
              <img src={RightChevron} alt="right chevron arrow" />
            </SubMenuItem>
          </a>
        ))}
      </SubItemList>
    </CommunityWrapper>
  )
}

export default MentalHealthTest
